<template>
  <div class="gr-main-container">
    <section class="mentions">
      <div class="uk-container">
        
      <h2>LA RESERVATION DE BALISE N’EST PLUS DISPONIBLE</h2>

      <p>Si vous êtes un coureur du Grand Raid 2026, veuillez bien vérifier vos nom, prénom et numéro de dossard, et réessayez !</p>
      <p>Si vous n'êtes pas un coureur du Grand Raid 2026, pas d’inquiétude, vous pourrez toujours louer votre balise* sur le stand SFR lors de la remise des dossard ce mercredi 14 octobre 2026.<br>Pensez à vous munir d’une carte bancaire physique et de votre pièce d’identité pour effectuer la réservation.<br><br><em>*dans la limite des stocks disponibles</em></p>

      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ChoixCoureurFin',
  props: {
    msg: String
  }
}
</script>
